// Channel types: auto-generated — do not edit that section by hand.
// This was last generated at 2026-07-01 06:43:17
// Source: backend/internal/constants/notifications.go (NotificationChannelType + NotificationChannelTypesAPI)
// Regenerate: make generate-notification-channel-types
//
// Predefined targets: mirrors backend PredefinedChannels + label strings; extend the Go generator when
// PredefinedChannelLabels exist in notifications.go.

/** All channel type string values defined in the backend. */
export type NotificationChannelType = "email" | "pagerduty" | "webhook";

/** Channel types accepted by POST /api/team/{id}/notifications/channels */
export type NotificationChannelTypeAPI = "email" | "webhook";

/** Ordered list matching backend constants.NotificationChannelTypesAPI. */
export const NOTIFICATION_CHANNEL_TYPES_API = ["email", "webhook"] as const;

/** Every defined backend type (for responses, badges, etc.). */
export const NOTIFICATION_CHANNEL_TYPES_ALL = [
	"email",
	"pagerduty",
	"webhook",
] as const;

/** Non-empty tuple for z.enum(...) from NOTIFICATION_CHANNEL_TYPES_API. */
export const NOTIFICATION_CHANNEL_TYPES_API_ZOD_ENUM =
	NOTIFICATION_CHANNEL_TYPES_API as unknown as [
		NotificationChannelTypeAPI,
		...NotificationChannelTypeAPI[],
	];

/** Label for UI (e.g. dropdown items). */
export function formatNotificationChannelTypeLabel(
	type: NotificationChannelType,
): string {
	return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}

// --- Predefined notification targets (role-based)

export type PredefinedNotificationChannel =
	| "notify_owner"
	| "notify_admin"
	| "notify_billing"
	| "notify_user";

/** Order matches backend constants.PredefinedChannels (rule editor). */
export const PREDEFINED_NOTIFICATION_CHANNELS = [
	"notify_owner",
	"notify_admin",
	"notify_billing",
	"notify_user",
] as const satisfies readonly PredefinedNotificationChannel[];

/** Full labels (rule editor), matching backend PredefinedChannelLabels when present. */
export const PREDEFINED_NOTIFICATION_CHANNEL_LABELS = {
	notify_owner: "Notify Owner",
	notify_admin: "Notify Admin",
	notify_billing: "Notify Billing",
	notify_user: "Notify Specific User",
} as const satisfies Record<PredefinedNotificationChannel, string>;

/** Short labels (e.g. rules table), matching backend PredefinedChannelShortLabels when present. */
export const PREDEFINED_NOTIFICATION_CHANNEL_SHORT_LABELS = {
	notify_owner: "Owner",
	notify_admin: "Admin",
	notify_billing: "Billing",
	notify_user: "Specific User",
} as const satisfies Record<PredefinedNotificationChannel, string>;

export function isPredefinedNotificationChannel(
	v: string,
): v is PredefinedNotificationChannel {
	return Object.hasOwn(PREDEFINED_NOTIFICATION_CHANNEL_SHORT_LABELS, v);
}

/** Order matches backend constants.UsageThresholdPercentsAllowed (usage rule editor). */
export const USAGE_THRESHOLD_PERCENTS_ALLOWED = [50, 75, 90, 100] as const;
